import { Box, Stack, Typography } from "@mui/material";
import type { ElementType } from "react";

export interface ComingSoonFeature {
  icon: ElementType;
  text: string;
}

interface ComingSoonFeaturesProps {
  subtitle: string;
  features: ComingSoonFeature[];
}

export default function ComingSoonFeatures({ subtitle, features }: ComingSoonFeaturesProps) {
  return (
    <Stack px={2} mt={2.5}>
      <Typography fontSize={16} color="#202020" letterSpacing="0.16px">{subtitle}</Typography>
      <Box sx={{ bgcolor: "#f0f3ff", borderRadius: "6px", p: "10px 15px", mt: 1 }}>
        <Stack gap={0.5}>
          {features.map((feature, i) => (
            <Stack key={i} direction="row" alignItems="center" gap={1}>
              <Box component={feature.icon} size={16} color="#202020" />
              <Typography fontSize={14} fontWeight={600} color="#202020">{feature.text}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
